import { render } from "./GameActivity.vue?vue&type=template&id=5d5e8f2d&scoped=true"
import script from "./GameActivity.vue?vue&type=script&lang=js"
export * from "./GameActivity.vue?vue&type=script&lang=js"

import "./GameActivity.vue?vue&type=style&index=0&id=5d5e8f2d&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5e8f2d"]])

export default __exports__